// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mDisplayBlock {
  display: block;
  background: rgba(0, 0, 0, 0.5);
}

.mGeneralMessageModalWidth {
  max-width: 65%;
}
.mGeneralMessageModalFullScreen {
  width: calc(100vw - 48px);
  max-width: 1480px;
  height: calc(100vh - 48px);
  margin: 24px auto;
}

.mGeneralMessageModalFullScreen .mGeneralMessageModalContent {
  height: 100%;
  max-height: calc(100vh - 48px);
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: var(--radius-lg, 10px);
  background: var(--surface-page, #f8fafc);
  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);
  overflow: hidden;
}

.mGeneralMessageModalFullScreen .mGeneralMessageModalHeader {
  flex: 0 0 auto;
  align-items: center;
  min-height: 76px;
  padding: 16px 22px;
  border-bottom: 1px solid var(--border-subtle, #e5e7eb);
  background: var(--surface-card, #fff);
}

.mGeneralMessageModalTitleWrap {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mGeneralMessageModalEyebrow {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.mGeneralMessageModalTitle {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 22px;
  line-height: 1.18;
  font-weight: 800;
  letter-spacing: 0;
}

.mGeneralMessageModalFullScreen .mGeneralMessageModalBody {
  flex: 1 1 auto;
  min-height: 0;
  padding: 18px 22px;
  overflow: auto;
  background: var(--surface-page, #f8fafc);
}

.mGeneralMessageModalFullScreen .mGeneralMessageModalFooter {
  flex: 0 0 auto;
  gap: 10px;
  padding: 12px 22px;
  border-top: 1px solid var(--border-subtle, #e5e7eb);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.08);
}

.mGeneralMessageModalFullScreen .btn {
  min-height: 36px;
  border-radius: var(--radius-md, 8px);
  padding: 0 14px;
  font-size: 13px;
  font-weight: 700;
  box-shadow: none;
}

.mGeneralMessageModalFullScreen .btn-primary {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
}

.mGeneralMessageModalFullScreen .btn-secondary {
  border-color: var(--border-default, #cbd5e1);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
}

.mGeneralMessageModalFullScreen .close {
  width: 36px;
  height: 36px;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: var(--radius-md, 8px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-card, #fff);
  color: var(--text-muted, #64748b);
  opacity: 1;
  text-shadow: none;
}

.mGeneralMessageModalFullScreen .progress {
  height: 8px;
  margin: 0 0 18px;
  border-radius: var(--radius-pill, 999px);
  background: var(--slate-100, #f1f5f9);
}

.mGeneralMessageModalFullScreen .progress-bar {
  background: var(--action-primary, #227ebd);
}

.mGeneralMessageModalFullScreen .alert {
  border-radius: var(--radius-md, 8px);
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #991b1b;
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm,
.mGeneralMessageModalFullScreen .bMessageTextForm {
  max-width: none;
  margin: 0;
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 16px;
  align-items: start;
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group {
  margin: 0;
  padding: 18px;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: var(--radius-lg, 10px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.05));
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(1),
.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(2) {
  grid-column: 1;
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.form-check,
.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.row {
  grid-column: 2;
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm .form-group.row {
  margin-left: 0;
  margin-right: 0;
  padding: 18px;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: var(--radius-lg, 10px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.05));
}

.mGeneralMessageModalFullScreen .bMessageSettingsForm label,
.mGeneralMessageModalFullScreen .bMessageTextForm label,
.mGeneralMessageModalFullScreen .bMessageSettingsForm .text-secondary {
  margin-bottom: 7px;
  color: var(--text-body, #334155) !important;
  font-size: 13px;
  font-weight: 700;
}

.mGeneralMessageModalFullScreen .form-control,
.mGeneralMessageModalFullScreen .form-control-file {
  min-height: 40px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  box-shadow: none;
}

.mGeneralMessageModalFullScreen .form-control:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.mGeneralMessageModalFullScreen .form-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-height: 44px;
}

.mGeneralMessageModalFullScreen .form-check-input {
  position: static;
  width: 18px;
  height: 18px;
  margin: 3px 0 0;
  flex: 0 0 auto;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 4px;
  background: #fff;
  appearance: none;
}

.mGeneralMessageModalFullScreen .form-check-input:checked {
  border-color: var(--action-primary, #227ebd);
  background-color: var(--action-primary, #227ebd);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m3 8 3 3 7-7'/%3E%3C/svg%3E");
  background-position: center;
  background-repeat: no-repeat;
  background-size: 14px;
}

.mGeneralMessageModalFullScreen .form-check-input:focus {
  outline: none;
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));
}

.mGeneralMessageModalFullScreen .form-check-label {
  margin: 0;
}

.mGeneralMessageModalFullScreen .form-check-inline {
  margin: 0 8px 8px 0;
  padding: 7px 10px;
  border: 1px solid var(--border-subtle, #e5e7eb);
  border-radius: var(--radius-pill, 999px);
  background: var(--slate-25, #f8fafc);
}

.mGeneralMessageModalFullScreen .bMessageTextForm .container-fluid,
.mGeneralMessageModalFullScreen .bMessageTextForm .row {
  margin: 0;
  padding: 0;
}

.mGeneralMessageModalFullScreen .bMessageTextForm .row {
  display: grid;
  grid-template-columns: minmax(420px, 1.4fr) minmax(280px, 0.8fr) minmax(280px, 0.8fr);
  gap: 16px;
}

.mGeneralMessageModalFullScreen .bMessageTextForm .col-md-6,
.mGeneralMessageModalFullScreen .bMessageTextForm .col-md-3 {
  max-width: none;
  flex: none;
  padding: 0;
}

.mGeneralMessageModalFullScreen .bMessageTextFormEmailEditor,
.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor,
.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor {
  height: auto;
  min-height: 0;
  margin: 0;
  padding: 18px;
  border: 1px solid var(--border-subtle, #e5e7eb) !important;
  border-radius: var(--radius-lg, 10px) !important;
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.05));
}

.mGeneralMessageModalFullScreen .bMessageTextFormEmailEditor {
  min-height: 620px;
}

.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor,
.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor {
  min-height: 420px;
}

.mGeneralMessageModalFullScreen .bMessageTextForm textarea.form-control {
  min-height: 260px;
  resize: vertical;
  line-height: 1.5;
}

.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor textarea.form-control,
.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor textarea.form-control {
  min-height: 300px;
}

.mGeneralMessageModalFullScreen .eMessageTextFormSmsEditorCounters {
  margin-top: 10px;
  color: var(--text-muted, #64748b) !important;
  font-size: 12px;
}

.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar,
.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-container {
  border-color: var(--border-default, #cbd5e1) !important;
}

.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar {
  border-radius: var(--radius-md, 8px) var(--radius-md, 8px) 0 0;
  background: var(--slate-50, #f8fafc);
}

.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar button,
.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar .ql-picker-label {
  border-radius: 6px;
}

.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar button:hover,
.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar button.ql-active,
.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar .ql-picker-label:hover {
  background: var(--surface-hover, #eef2f6);
  color: var(--action-primary, #227ebd);
}

.mGeneralMessageModalFullScreen .gmPreview {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 390px;
  gap: 20px;
  align-items: start;
}

.mGeneralMessageModalFullScreen .gmPreview__main,
.mGeneralMessageModalFullScreen .gmPreview__recipients {
  min-width: 0;
}

.mGeneralMessageModalFullScreen .gmPreview__title {
  margin: 0 0 10px;
  color: var(--text-subtle, #94a3b8);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.mGeneralMessageModalFullScreen .gmPreviewTabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.mGeneralMessageModalFullScreen .gmPreviewTabs__tab {
  min-height: 34px;
  padding: 7px 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 750;
}

.mGeneralMessageModalFullScreen .gmPreviewTabs__tab--active {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.mGeneralMessageModalFullScreen .gmPreviewCard {
  overflow: hidden;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: #fff;
}

.mGeneralMessageModalFullScreen .gmAffected {
  min-width: 0;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
}

.mGeneralMessageModalFullScreen .gmAffected__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-wrap: wrap;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
}

.mGeneralMessageModalFullScreen .gmAffected__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.mGeneralMessageModalFullScreen .gmAffected__stats span {
  display: inline-flex;
  min-height: 26px;
  align-items: center;
  padding: 4px 9px;
  border-radius: 8px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
}

.mGeneralMessageModalFullScreen .gmAffected__tableWrap {
  width: 100%;
  max-height: 420px;
  margin-top: 12px;
  overflow: auto;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 12px;
}

.mGeneralMessageModalFullScreen .gmAffected__table {
  width: 100%;
  min-width: 560px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  font-size: 12px;
}

.mGeneralMessageModalFullScreen .gmAffected__table th,
.mGeneralMessageModalFullScreen .gmAffected__table td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  overflow-wrap: anywhere;
  text-align: left;
  vertical-align: top;
}

.mGeneralMessageModalFullScreen .gmAffected__table th {
  position: sticky;
  z-index: 1;
  top: 0;
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
}

.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-container {
  min-height: 300px;
  border-radius: 0 0 var(--radius-md, 8px) var(--radius-md, 8px);
  font-size: 14px;
}

.mGeneralMessageModalFullScreen .bMessageTextFormEmailEditor > div:not(:last-child),
.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor > div:not(:last-child),
.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor > div:not(:last-child) {
  margin-bottom: 14px;
}

@media (max-width: 1180px) {
  .mGeneralMessageModalFullScreen .bMessageSettingsForm,
  .mGeneralMessageModalFullScreen .bMessageTextForm .row {
    grid-template-columns: 1fr;
  }

  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group,
  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(1),
  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(2),
  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.form-check,
  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.row {
    grid-column: 1;
  }
}

@media (max-width: 760px) {
  .mGeneralMessageModalFullScreen {
    width: 100vw;
    height: 100vh;
    margin: 0;
  }

  .mGeneralMessageModalFullScreen .mGeneralMessageModalContent {
    max-height: 100vh;
    border-radius: 0;
  }

  .mGeneralMessageModalFullScreen .mGeneralMessageModalHeader,
  .mGeneralMessageModalFullScreen .mGeneralMessageModalBody,
  .mGeneralMessageModalFullScreen .mGeneralMessageModalFooter {
    padding-left: 14px;
    padding-right: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/GeneralMessageModal/MessageModal.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,+CAA+C;EAC/C,qCAAqC;EACrC,wCAAwC;EACxC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,mDAAmD;EACnD,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,0CAA0C;AAC5C;;AAEA;EACE,4CAA4C;EAC5C,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;;;EAGE,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,gDAAgD;EAChD,6OAA6O;EAC7O,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mEAAmE;AACrE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,qFAAqF;EACrF,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,UAAU;EACV,UAAU;AACZ;;AAEA;;;EAGE,YAAY;EACZ,aAAa;EACb,SAAS;EACT,aAAa;EACb,0DAA0D;EAC1D,gDAAgD;EAChD,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;;EAEE,uDAAuD;AACzD;;AAEA;EACE,8DAA8D;EAC9D,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;EAGE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,sDAAsD;EACtD,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,oCAAoC;EACpC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,8DAA8D;EAC9D,eAAe;AACjB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;;;IAGE,kBAAkB;IAClB,mBAAmB;EACrB;AACF","sourcesContent":[".mDisplayBlock {\n  display: block;\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.mGeneralMessageModalWidth {\n  max-width: 65%;\n}\n.mGeneralMessageModalFullScreen {\n  width: calc(100vw - 48px);\n  max-width: 1480px;\n  height: calc(100vh - 48px);\n  margin: 24px auto;\n}\n\n.mGeneralMessageModalFullScreen .mGeneralMessageModalContent {\n  height: 100%;\n  max-height: calc(100vh - 48px);\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: var(--radius-lg, 10px);\n  background: var(--surface-page, #f8fafc);\n  box-shadow: 0 24px 70px rgba(15, 23, 42, 0.24);\n  overflow: hidden;\n}\n\n.mGeneralMessageModalFullScreen .mGeneralMessageModalHeader {\n  flex: 0 0 auto;\n  align-items: center;\n  min-height: 76px;\n  padding: 16px 22px;\n  border-bottom: 1px solid var(--border-subtle, #e5e7eb);\n  background: var(--surface-card, #fff);\n}\n\n.mGeneralMessageModalTitleWrap {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mGeneralMessageModalEyebrow {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.mGeneralMessageModalTitle {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 22px;\n  line-height: 1.18;\n  font-weight: 800;\n  letter-spacing: 0;\n}\n\n.mGeneralMessageModalFullScreen .mGeneralMessageModalBody {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 18px 22px;\n  overflow: auto;\n  background: var(--surface-page, #f8fafc);\n}\n\n.mGeneralMessageModalFullScreen .mGeneralMessageModalFooter {\n  flex: 0 0 auto;\n  gap: 10px;\n  padding: 12px 22px;\n  border-top: 1px solid var(--border-subtle, #e5e7eb);\n  background: rgba(255, 255, 255, 0.96);\n  box-shadow: 0 -10px 28px rgba(15, 23, 42, 0.08);\n}\n\n.mGeneralMessageModalFullScreen .btn {\n  min-height: 36px;\n  border-radius: var(--radius-md, 8px);\n  padding: 0 14px;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: none;\n}\n\n.mGeneralMessageModalFullScreen .btn-primary {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n}\n\n.mGeneralMessageModalFullScreen .btn-secondary {\n  border-color: var(--border-default, #cbd5e1);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n}\n\n.mGeneralMessageModalFullScreen .close {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: var(--radius-md, 8px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--surface-card, #fff);\n  color: var(--text-muted, #64748b);\n  opacity: 1;\n  text-shadow: none;\n}\n\n.mGeneralMessageModalFullScreen .progress {\n  height: 8px;\n  margin: 0 0 18px;\n  border-radius: var(--radius-pill, 999px);\n  background: var(--slate-100, #f1f5f9);\n}\n\n.mGeneralMessageModalFullScreen .progress-bar {\n  background: var(--action-primary, #227ebd);\n}\n\n.mGeneralMessageModalFullScreen .alert {\n  border-radius: var(--radius-md, 8px);\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  color: #991b1b;\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm,\n.mGeneralMessageModalFullScreen .bMessageTextForm {\n  max-width: none;\n  margin: 0;\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 16px;\n  align-items: start;\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group {\n  margin: 0;\n  padding: 18px;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: var(--radius-lg, 10px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.05));\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(1),\n.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(2) {\n  grid-column: 1;\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.form-check,\n.mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.row {\n  grid-column: 2;\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm .form-group.row {\n  margin-left: 0;\n  margin-right: 0;\n  padding: 18px;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: var(--radius-lg, 10px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.05));\n}\n\n.mGeneralMessageModalFullScreen .bMessageSettingsForm label,\n.mGeneralMessageModalFullScreen .bMessageTextForm label,\n.mGeneralMessageModalFullScreen .bMessageSettingsForm .text-secondary {\n  margin-bottom: 7px;\n  color: var(--text-body, #334155) !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.mGeneralMessageModalFullScreen .form-control,\n.mGeneralMessageModalFullScreen .form-control-file {\n  min-height: 40px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  box-shadow: none;\n}\n\n.mGeneralMessageModalFullScreen .form-control:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.mGeneralMessageModalFullScreen .form-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-height: 44px;\n}\n\n.mGeneralMessageModalFullScreen .form-check-input {\n  position: static;\n  width: 18px;\n  height: 18px;\n  margin: 3px 0 0;\n  flex: 0 0 auto;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 4px;\n  background: #fff;\n  appearance: none;\n}\n\n.mGeneralMessageModalFullScreen .form-check-input:checked {\n  border-color: var(--action-primary, #227ebd);\n  background-color: var(--action-primary, #227ebd);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath fill='none' stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m3 8 3 3 7-7'/%3E%3C/svg%3E\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 14px;\n}\n\n.mGeneralMessageModalFullScreen .form-check-input:focus {\n  outline: none;\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.16));\n}\n\n.mGeneralMessageModalFullScreen .form-check-label {\n  margin: 0;\n}\n\n.mGeneralMessageModalFullScreen .form-check-inline {\n  margin: 0 8px 8px 0;\n  padding: 7px 10px;\n  border: 1px solid var(--border-subtle, #e5e7eb);\n  border-radius: var(--radius-pill, 999px);\n  background: var(--slate-25, #f8fafc);\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextForm .container-fluid,\n.mGeneralMessageModalFullScreen .bMessageTextForm .row {\n  margin: 0;\n  padding: 0;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextForm .row {\n  display: grid;\n  grid-template-columns: minmax(420px, 1.4fr) minmax(280px, 0.8fr) minmax(280px, 0.8fr);\n  gap: 16px;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextForm .col-md-6,\n.mGeneralMessageModalFullScreen .bMessageTextForm .col-md-3 {\n  max-width: none;\n  flex: none;\n  padding: 0;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextFormEmailEditor,\n.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor,\n.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor {\n  height: auto;\n  min-height: 0;\n  margin: 0;\n  padding: 18px;\n  border: 1px solid var(--border-subtle, #e5e7eb) !important;\n  border-radius: var(--radius-lg, 10px) !important;\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.05));\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextFormEmailEditor {\n  min-height: 620px;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor,\n.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor {\n  min-height: 420px;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextForm textarea.form-control {\n  min-height: 260px;\n  resize: vertical;\n  line-height: 1.5;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor textarea.form-control,\n.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor textarea.form-control {\n  min-height: 300px;\n}\n\n.mGeneralMessageModalFullScreen .eMessageTextFormSmsEditorCounters {\n  margin-top: 10px;\n  color: var(--text-muted, #64748b) !important;\n  font-size: 12px;\n}\n\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar,\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-container {\n  border-color: var(--border-default, #cbd5e1) !important;\n}\n\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar {\n  border-radius: var(--radius-md, 8px) var(--radius-md, 8px) 0 0;\n  background: var(--slate-50, #f8fafc);\n}\n\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar button,\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar .ql-picker-label {\n  border-radius: 6px;\n}\n\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar button:hover,\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar button.ql-active,\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-toolbar .ql-picker-label:hover {\n  background: var(--surface-hover, #eef2f6);\n  color: var(--action-primary, #227ebd);\n}\n\n.mGeneralMessageModalFullScreen .gmPreview {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 390px;\n  gap: 20px;\n  align-items: start;\n}\n\n.mGeneralMessageModalFullScreen .gmPreview__main,\n.mGeneralMessageModalFullScreen .gmPreview__recipients {\n  min-width: 0;\n}\n\n.mGeneralMessageModalFullScreen .gmPreview__title {\n  margin: 0 0 10px;\n  color: var(--text-subtle, #94a3b8);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.mGeneralMessageModalFullScreen .gmPreviewTabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.mGeneralMessageModalFullScreen .gmPreviewTabs__tab {\n  min-height: 34px;\n  padding: 7px 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 750;\n}\n\n.mGeneralMessageModalFullScreen .gmPreviewTabs__tab--active {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.mGeneralMessageModalFullScreen .gmPreviewCard {\n  overflow: hidden;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: #fff;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected {\n  min-width: 0;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  flex-wrap: wrap;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__stats span {\n  display: inline-flex;\n  min-height: 26px;\n  align-items: center;\n  padding: 4px 9px;\n  border-radius: 8px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__tableWrap {\n  width: 100%;\n  max-height: 420px;\n  margin-top: 12px;\n  overflow: auto;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 12px;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__table {\n  width: 100%;\n  min-width: 560px;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n  font-size: 12px;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__table th,\n.mGeneralMessageModalFullScreen .gmAffected__table td {\n  padding: 8px 10px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  overflow-wrap: anywhere;\n  text-align: left;\n  vertical-align: top;\n}\n\n.mGeneralMessageModalFullScreen .gmAffected__table th {\n  position: sticky;\n  z-index: 1;\n  top: 0;\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.mGeneralMessageModalFullScreen .eMessageTextEditor .ql-container {\n  min-height: 300px;\n  border-radius: 0 0 var(--radius-md, 8px) var(--radius-md, 8px);\n  font-size: 14px;\n}\n\n.mGeneralMessageModalFullScreen .bMessageTextFormEmailEditor > div:not(:last-child),\n.mGeneralMessageModalFullScreen .bMessageTextFormPushEditor > div:not(:last-child),\n.mGeneralMessageModalFullScreen .bMessageTextFormSmsEditor > div:not(:last-child) {\n  margin-bottom: 14px;\n}\n\n@media (max-width: 1180px) {\n  .mGeneralMessageModalFullScreen .bMessageSettingsForm,\n  .mGeneralMessageModalFullScreen .bMessageTextForm .row {\n    grid-template-columns: 1fr;\n  }\n\n  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group,\n  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(1),\n  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group:nth-child(2),\n  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.form-check,\n  .mGeneralMessageModalFullScreen .bMessageSettingsForm > .form-group.row {\n    grid-column: 1;\n  }\n}\n\n@media (max-width: 760px) {\n  .mGeneralMessageModalFullScreen {\n    width: 100vw;\n    height: 100vh;\n    margin: 0;\n  }\n\n  .mGeneralMessageModalFullScreen .mGeneralMessageModalContent {\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .mGeneralMessageModalFullScreen .mGeneralMessageModalHeader,\n  .mGeneralMessageModalFullScreen .mGeneralMessageModalBody,\n  .mGeneralMessageModalFullScreen .mGeneralMessageModalFooter {\n    padding-left: 14px;\n    padding-right: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
